module.exports = __webpack_public_path__ + "b0524241b9abb6afe396047e8df90b12.pdf";